<template>
  <div class="search_menhui" @click.stop="closeSea" @scroll.stop>
    <div class="search_box" :class="isUnMonut?'search_box_close':''" @click.stop="aa">
        <div class="search1">
            <el-icon class="Search"><Search /></el-icon>
            <input type="text" v-model="inputVa" placeholder="资源搜索" class="search_inp">
            <el-icon class="Close" @click.stop="cleanInput" v-if="isShowClose"><Close /></el-icon>
        </div>
        <div class="recommend" v-if="searList.length===0&&!isPic404">
            <ul><li v-for="i,index in hopkeyList" :key="index" @click="searitem(i.name)"><a>{{i.name}}</a></li></ul>
        </div>
        <div class="sear_list" v-else>
            <div class="sear_item" v-for="i,index in searList" :key="index" @click="gourl(i)">
                <div class="item1">
                    <div class="item1_imgF">
                        <img :src="enn+i.picurl" alt="">
                    </div>
                    <div class="item1_jie">
                        <div class="jie_name">{{ i.name }}</div>
                        <div class="jie_ramadk">
                            <div v-for="j,index in i.typelist" :key="index" class="jie_item">
                                <div>{{ j }}</div>
                                <div v-if="index+1!==i.typelist.length" class="heng">|</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item2">{{ i.ramack }}</div>
            </div>
        </div>
        <div class="cardItem404" v-if="isPic404">
            <img :src="picurl404" alt="">
        </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, onBeforeUnmount,ref,defineEmits,reactive, watch, computed} from 'vue'
import {GetHopkey,GetItem,Onclick} from "@/api"
import {useStore} from 'vuex'

const store = useStore()
const inputVa = ref(null)
const isUnMonut = ref(false)
const isShowClose = ref(false)
const isPic404 = ref(false)
const picurl404 = computed(()=>{return store.state.app.sysinfo.pic404url})
const enn = process.env.VUE_APP_PIC_URL


const param = reactive({
    pageNum:1,
    pageSize:100,
    type:null,
    name:null,
    isHop:false
})

const searList = ref([])
const hopkeyList = ref([])

watch(inputVa,()=>{
    isPic404.value = false
    if(inputVa.value==='') {
        searList.value =[]
        isPic404.value = false
        isShowClose.value = false
        return
    }
    isShowClose.value = true
    param.name = inputVa.value
    GetItem(param).then(res=>{
        if(res.records.length===0) {isPic404.value = true}
        searList.value = res.records
        searList.value.forEach(i=>{
            i.typelist = i.typelist.split('，')
        })
    })
})

onMounted(()=>{
    GetHopkey().then(res=>{
        hopkeyList.value = res
    }).catch()
})

const searitem =(text)=>{
    inputVa.value = text
}
const cleanInput = ()=>{inputVa.value=''}
const handClose = defineEmits(['handClose'])

const gourl = (val)=>{
    Onclick(val.id).then().catch()
    window.open(val.gourl)
}

onBeforeUnmount(()=>{
    isUnMonut.value = true
})

const closeSea = ()=>{
    handClose('handClose',false)
}

const aa = ()=>{}

</script>

<style lang="scss" scoped>
div::-webkit-scrollbar{
    // display:none
    width: .5rem;
    background: var(--searchdetails-scrollbar-bac);
}
div::-webkit-scrollbar-thumb{
    // display:none
    background: var(--searchdetails-scrollbar-thumb);
}
.search_menhui{
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 30;
    background: rgb(0 0 0 / 50%);
    .search_box{
        overflow: hidden;
        position: fixed;
        // top: 4vh;
        left: 50%;
        width: 50rem;
        // height: 10vh;
        transform: translateX(-50%);
        background: var(--searchdetails-sear-list-bac);
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 12;
        border-radius: 20px;
        animation: search_boxin .2s ease-in-out forwards;
        transition: all .2s ease-in-out;
        @keyframes search_boxin
        {
            0%   {top: 0;opacity: 0;}
            100% {top: 4vh;opacity: 1;}
        }
        &.search_box_close{
            background: red;
            animation: search_boxout .2s ease-in-out forwards;
        }
        @keyframes search_boxout
        {
            0%   {top: 4vh;opacity: 1;}
            100% {top: 0;opacity: 0;}
        }
        .search1{
            width: inherit;
            height: 3rem;
            border-radius: inherit;
            border-radius: 20px 20px 0 0;
            display: flex;
            align-items: center;
            background: var(--searchdetails-sear1-bac);
            
            .Search{
                color: var(--searchdetails-icon);
                scale: 1.2;
                position: absolute;
                left: 1rem;
            }
            .Close{
                color: var(--searchdetails-icon);
                scale: 1.5;
                cursor: pointer;
                position: absolute;
                right: 1rem;
            }
            .search_inp{
                position: absolute;
                left: 3rem;
                outline: none;
                border:none;
                background: var(--searchdetails-sear1-bac);
                font-size: 17px;
                font-weight: 500;
                color: var(--searchdetails-recommend-li-color);
                width: 30vw;
            }
            input::-webkit-input-placeholder{ /* WebKit browsers */    opacity: .7;}
        }
        .recommend{
            margin-top: 2vh;
            margin-bottom: 5vh;
            padding: 0 1vw;
            width: inherit;
            // height: 10vh;
            display: flex;
            z-index: 12;
            >ul{
                width: 100%;
                padding: 0;
                >li{
                    margin-right: 12px;
                    margin-bottom: 12px;
                    line-height: 2.6;
                    font-size: 0.875rem;
                    display: inline-block;
                    position: relative;
                    background-color: var(--dn-gray-50);
                    border-radius: 8px;
                    background: var(--searchdetails-recommend-li-bac);
                    cursor: pointer;
                    >a{
                        font-size: 0.875rem;
                        font-weight: 500;
                        line-height: 20px;
                        padding: 0.5rem 1rem;
                        // -webkit-transition: all 0.2s ease-in-out;
                        // transition: all 0.2s ease-in-out;
                        color: var(--searchdetails-recommend-li-color);
                        text-decoration: none;
                    
                    }
                }
            }
        }
        .sear_list{
            width: inherit;
            // height: 10vh;
            // background: var(--searchdetails-sear-list-bac);
            max-height: 40rem;
            overflow: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 2rem;
            .sear_item{
                cursor: pointer;
                width: 95%;
                height: 7vh;
                // border-bottom: 1px solid var(--searchdetails-sear-item-heng-bac);
                margin: 10px;
                padding: 1rem;
                display: flex;
                align-items: center;
                .item1{
                    flex:.8;
                    display: flex;
                    .item1_imgF{
                        // flex:.2;
                        width: 3.5rem;
                        height: 3.5rem;
                        border-radius: 1rem;
                        background: var(--searchdetails-sear-item-img-bac);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        img{
                            width: 70%;
                            height: 70%;
                            // padding: 10px;
                            border-radius: 1rem;
                            transition: opacity .1s ease-in-out;
                        }
                    }
                    .item1_jie{
                        flex:.8;
                        display: flex;
                        flex-direction: column;
                        margin-left: 1rem;
                        margin-top: .3rem;
                        justify-content: space-around;
                        .jie_name{
                            flex:.6;
                            // line-height: 2rem;
                            font-size: 1rem;
                            font-weight: 500;
                            color:var(--searchdetails-sear-item-name-color);
                        }
                        .jie_ramadk{
                            flex:.4;
                            display: flex;
                            font-size: 12px;
                            .jie_item{
                                display: flex;
                                color:#b0b0b0;
                                font-size: .7rem;
                            }
                            .heng{
                                color:#b0b0b0;
                                margin: 0 10px;
                            }
                        }
                    }
                }
                .item2{
                    flex:1.2;
                    font-size: 13px;
                    color:#b0b0b0;
                    opacity: .8;
                }
            }
            .sear_item:hover{
                .item1_imgF{
                    img{
                        scale: 1.1;
                    }
                }
            }
        }
        .cardItem404{
            img{
                width: 40rem;
                padding: 2rem;
            }
        }
    }
}
</style>